export const SET_LOADING_CONFIRM_SUCCESS = 'SET_LOADING_CONFIRM_SUCCESS'
